import React, { useState } from 'react';
import Header from './common/Header';
import Footer from './common/Footer';
import SEO from '../components/common/SEO';

function Vendor() {
    const [records, setRecords] = useState([]); // Array to store all records
    const [visibleRecords, setVisibleRecords] = useState([]); // Array for visible records
    const [currentPage, setCurrentPage] = useState(1); // Tracks current page
    const recordsPerPage = 40;

    // Simulated API records (replace with actual API call)
    const allRecords = Array.from({ length: 200 }, (_, i) => ({
        id: i + 1,
        name: `Vendor ${i + 1}`,
        description: `Description of Vendor ${i + 1}`,
        image: 'assets/img/tours-details/arunachal-package.jpg',
        rating: (Math.random() * (5 - 3) + 3).toFixed(1),
    }));

    // Initialize records when the component mounts
    React.useEffect(() => {
        setRecords(allRecords);
        setVisibleRecords(allRecords.slice(0, recordsPerPage));
    }, []);

    // Load more records
    const loadMore = () => {
        const nextPage = currentPage + 1;
        const startIndex = currentPage * recordsPerPage;
        const endIndex = startIndex + recordsPerPage;
        setVisibleRecords((prev) => [...prev, ...records.slice(startIndex, endIndex)]);
        setCurrentPage(nextPage);
    };

    return (
        <div>
            <SEO title="Our Verified Vendors & Partners | Mangoloops" description="Browse through our verified vendors and partners at Mangoloops. We connect you with the best travel and healthcare service providers." />
            <Header />
            <main id="content">
                <div className="banner-content tour-search-sec text-center mb-5 mb-lg-8">
                    <div className="container-fluid">
                        <div className="row justify-content-center py-xl-4">
                            <div className="col-lg-6">
                                <div className="card-body">
                                    <form className="form-container search-input-form">
                                        <div className="search-container">
                                            <span>
                                                <i className="fa fa-search search-icon"></i>
                                            </span>
                                            <input
                                                type="text"
                                                placeholder="Search Vendors!"
                                                className="search-input"
                                            />
                                            <button className="search-button">Search</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mb-7">
                    <div className="container">
                        <div className="row">
                            {visibleRecords.map((record) => (
                                <div className="col-xl-3 col-lg-6 col-md-6 col-6 mb-3 px-1" key={record.id}>
                                <div className="tour-box th-ani">
                                        <a href="/react/vendor_details" className="card-link">
                                            <div className="package-image">
                                                <img src={record.image} alt="Vendor" />
                                            </div>
                                            <div className="tour-content">
                                                <h2 className="vendors-details-h2">{record.name}</h2>
                                                <p className="vendor-description">{record.description}</p>
                                                <div className="vendors-sec-main">
                                                    <div className="vendors-sec-main-div">
                                                        <div className="tour-action vendor-sec p-0 gap-vendor desktop-sec">
                                                            <span className="timing-office font-size-mob text-nowrap">9 AM - 7 PM</span>
                                                            <div className="th-btn style4 th-icon rating-count-sec height-vendor-listing">
                                                                {record.rating}{' '}
                                                                <i className="fa fa-star"></i>
                                                                <span className="review-text">(10 reviews)</span>
                                                            </div>
                                                        </div>
                                                        <div className="tour-action vendor-sec p-0 mobile-sec text-center">
                                                            {/* <span className="timing-office font-size-mob text-nowrap">9 AM - 7 PM</span> */}
                                                            <div className="th-btn style4 th-icon rating-count-sec height-vendor-listing text-wrap font-mobile">
                                                                {record.rating}{' '}
                                                                <i className="fa fa-star font-mobile"></i>
                                                                <span className="review-text-mobile font-mobile text-nowrap color-white">(10 reviews)</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {visibleRecords.length < records.length && (
                            <div className="text-center">
                                <button
                                    className="btn btn-primary"
                                    onClick={loadMore}
                                >
                                   More Search Results
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default Vendor;
